import React, { useEffect, useRef, useState } from "react";

const CurrencyDropdown = ({
  currencies,
  selectedToCurrency,
  handleToCurrencyChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const handleSelect = (currency) => {
    handleToCurrencyChange({ target: { value: currency.currency } });
    setIsOpen(false);
    setSearchTerm(""); // Clear search on selection
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredCurrencies = currencies
  .filter((cur) => cur.currency !== "INR") // exclude INR explicitly
  .filter((cur) =>
    cur.currency.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div ref={dropdownRef} className="relative Z-100">
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className="text-[0.75rem] gap-2 md:text-base border-none font-bold p-2 rounded focus:outline-none focus:ring-0 w-full flex justify-between items-center scrollbar-hide"
      >
        <img
          src={selectedToCurrency.image}
          alt={selectedToCurrency.currency}
          className="h-5 w-5 md:w-8 md:h-8 ml-2"
        />
        <span>{selectedToCurrency.currency}</span>
        <img src="/assets/arrow-down.png" alt="dropdown" className="" />
      </button>

      {isOpen && (
        <div className="absolute z-50 top-full left-0 p-2 bg-white border rounded h-[300px] border-[#FFDEE4] overflow-hidden shadow-[0px_6px_10.4px_0px_rgba(220,20,60,0.18)]">
          {/* Search Input */}
          <input
            type="text"
            placeholder="Search currency..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full p-2  rounded-md text-[0.75rem] border border-gray-300 outline-none"
          />

          {/* Currency List */}
          <div className="h-[260px] overflow-y-auto country-scrollbar">
            {filteredCurrencies.length > 0 ? (
              filteredCurrencies.map((cur) => (
                <div
                  key={cur.currency}
                  onClick={() => handleSelect(cur)}
                  className="flex items-center p-2 cursor-pointer"
                >
                  <img
                    src={cur.image}
                    alt={cur.currency}
                    className="h-5 w-5 md:w-8 md:h-8 mr-2"
                  />
                  <span className="text-[0.875rem] text-[#1E1E1E] font-bold ml-2">
                    {cur.currency}
                  </span>
                </div>
              ))
            ) : (
              <p className="p-4 text-gray-500 text-center">No results found</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencyDropdown;

// import React, { useState } from "react";

// const CurrencyDropdown = ({
//   currencies,
//   selectedCurrency,
//   onChange,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   const handleSelect = (currency) => {
//     onChange({ target: { value: currency.currency } });
//     setIsOpen(false);
//     setSearchTerm(""); // Clear search on selection
//   };

//   const filteredCurrencies = currencies.filter((cur) =>
//     cur.currency.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="relative Z-100">
//       <button
//         onClick={() => setIsOpen((prev) => !prev)}
//         className="text-[0.75rem] gap-2 md:text-base border-none font-bold p-2 rounded focus:outline-none focus:ring-0 w-full flex justify-between items-center scrollbar-hide"
//       >
//         <img
//           src={selectedCurrency?.image}
//           alt={selectedCurrency?.currency}
//           className="h-5 w-5 md:w-8 md:h-8 ml-2"
//         />
//         <span>{selectedCurrency?.currency}</span>
//         <img src="/assets/arrow-down.png" alt="dropdown" className="" />
//       </button>

//       {isOpen && (
//         <div className="absolute z-50 top-full left-0 p-2 bg-white border rounded h-[300px] border-[#FFDEE4] overflow-hidden shadow-[0px_6px_10.4px_0px_rgba(220,20,60,0.18)]">
//           {/* Search Input */}
//           <input
//             type="text"
//             placeholder="Search currency..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="w-full p-2 rounded-md text-[0.75rem] border border-gray-300 outline-none"
//           />

//           {/* Currency List */}
//           <div className="h-[260px] overflow-y-auto country-scrollbar">
//             {filteredCurrencies.length > 0 ? (
//               filteredCurrencies.map((cur) => (
//                 <div
//                   key={cur.currency}
//                   onClick={() => handleSelect(cur)}
//                   className="flex items-center p-2 cursor-pointer"
//                 >
//                   <img
//                     src={cur.image}
//                     alt={cur.currency}
//                     className="h-5 w-5 md:w-8 md:h-8 mr-2"
//                   />
//                   <span className="text-[0.875rem] text-[#1E1E1E] font-bold ml-2">
//                     {cur.currency}
//                   </span>
//                 </div>
//               ))
//             ) : (
//               <p className="p-4 text-gray-500 text-center">No results found</p>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CurrencyDropdown;
